import { createSelector } from '@reduxjs/toolkit';
import {RootState} from "../store.ts";

const selectPromts = (state: RootState) => state.generation.prompts;

export const selectInitialPhoto = createSelector(
    [selectPromts],
    (promts) => promts.find((p) => p.type === 'InitialImage')
);
